import { useMutation } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { api } from '../lib/api.js';
import { useWorkspaceStore } from '../stores/workspace.js';
import type { Workspace } from '@mayksel/types';
import type { UpdateWorkspaceInput } from '@mayksel/validators';

function useApiOpts() {
  const { getToken } = useAuth();
  const workspaceId = useWorkspaceStore((s) => s.workspace?.id);
  return { getToken, workspaceId };
}

export function useUpdateWorkspace() {
  const { getToken, workspaceId } = useApiOpts();
  const setWorkspaceData = useWorkspaceStore((s) => s.setWorkspaceData);
  const user = useWorkspaceStore((s) => s.user);

  return useMutation({
    mutationFn: async (data: UpdateWorkspaceInput) => {
      const token = await getToken();
      const opts: { token?: string; workspaceId?: string } = {};
      if (token) opts.token = token;
      if (workspaceId) opts.workspaceId = workspaceId;
      return api.patch<{ data: Workspace }>('/v1/workspaces', data, opts);
    },
    onSuccess: (res) => {
      // Keep the workspace store in sync so labels update immediately throughout the app
      if (user) setWorkspaceData(res.data, user);
    },
  });
}
